import { render } from "./boatType.vue?vue&type=template&id=0520e445&scoped=true"
import script from "./boatType.vue?vue&type=script&lang=js"
export * from "./boatType.vue?vue&type=script&lang=js"

import "./boatType.vue?vue&type=style&index=0&id=0520e445&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0520e445"]])

export default __exports__